<template>
  <div id="global" class="global global-padding pt-0">
    <div class="container">
      <div
        class="head d-flex flex-column justify-content-center align-items-center gap-4"
      >
        <h3 class="heading">Global Presence</h3>
        <p class="text-center w-75">
          IRISUNITED Group Holding's operations span across key global markets,
          allowing us to meet the diverse needs of our clients and customers
          worldwide.
        </p>
      </div>

      <div
        class="tab d-flex flex-column justify-content-center align-items-center gap-5"
      >
        <div class="network w-fit d-flex gap-2 align-items-center">
          <div class="global-icon">
            <!-- SVG icon هنا -->
          </div>

          <!-- Dynamic Tabs -->
          <ul class="nav nav-pills gap-2" id="pills-tab" role="tablist">
            <li
              v-for="(tab, index) in tabs"
              :key="tab.id"
              class="nav-item"
              role="presentation"
            >
              <button
                class="nav-link"
                :class="{ active: index === 0 }"
                :id="`${tab.id}-tab`"
                data-bs-toggle="pill"
                :data-bs-target="`#${tab.id}`"
                type="button"
                role="tab"
                :aria-controls="tab.id"
                :aria-selected="index === 0"
              >
                {{ tab.label }}
              </button>
            </li>
          </ul>
        </div>

        <!-- Dynamic Tab Content -->
        <div class="tab-content w-100" id="pills-tabContent">
          <div
            v-for="(tab, tabIndex) in tabs"
            :key="tab.id"
            class="tab-pane fade"
            :class="{ 'show active': tabIndex === 0 }"
            :id="tab.id"
            role="tabpanel"
            :aria-labelledby="`${tab.id}-tab`"
          >
            <!-- Filter Input -->
            <input
              v-model="tabFilters[tab.id]"
              type="text"
              placeholder="Filter by tag or title..."
              class="form-control mb-3"
            />

            <!-- Accordion Items -->
            <div
              v-for="(item, accIndex) in filteredAccordion(tab)"
              :key="accIndex"
              class="card mb-3"
              @mouseenter="hovered = accIndex"
              @mouseleave="hovered = null"
            >
              <h2
                class="d-flex align-items-center justify-content-between mb-0 gap-3"
              >
                <span class="p-0 d-flex align-items-center gap-2">
                  <img :src="item.icon" alt="icon" />
                  {{ item.title }}
                </span>
                <span class="tag" style="padding: 8px 16px">{{
                  item.tag
                }}</span>
              </h2>
              <transition name="fade">
                <p v-if="hovered === accIndex" class="mt-2 mb-0">
                  {{ item.description }}
                </p>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";

const hovered = ref(null);

// Filters لكل تاب
const tabFilters = reactive({});

// Tabs data
const tabs = [
  {
    id: "pills-global",
    label: "Global Network",
    accordion: [
      {
        icon: "/images/yellowBullet.svg",
        title: "Riyadh, Kingdom of Saudi Arabia-",
        tag: "headquarter Global",
        description:
          "IRISUNITED INVESTING GROUP LTD Serves as the principal holding of3ice and corporate command center. It provides strategic direction, 3inancial governance, and oversees the group’s long-term vision for sustainable global growth.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai, China",
        tag: "Headquarters",
        description:
          "IRISUNITED INVESTING GROUP LTD is the main holding group managing a network of domestic and international companies. It oversees operations, ensuring alignment with strategic goals and efficient resource utilization across subsidiaries.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai, China",
        tag: "Vehicle Export",
        description:
          "The Shanghai Import and Export Company specializes in serving the Shanghai market, with a focus on the export of cars and vehicles to the global market. This branch ensures streamlined operations, compliance with international trade standards, and the delivery of high-quality vehicles, catering to the demands of both domestic and international clients.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai, China",
        tag: "Trading Hub",
        description:
          "Shanghai IRISUNITED is the hub for our global investment and trading activities, specializing in manufacturing, supply, and distribution across various commodities. , Shanghai IRISUNITED plays a vital role in the development and deployment of our various needs of our customers and connections.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai, China",
        tag: "Retail & Food Trade",
        description:
          "Shanghai Alriyad Company operates supermarkets, online stores, and the Milestone Center, which serves as a platform for distributing international and imported food products while fostering trade relations between China and the Arab world. The center emphasizes the exchange of goods and cultural insights, contributing to enhanced cooperation and mutual benefit between these regions.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Yiwu, China",
        tag: "Commodities Ops",
        description:
          "Yiwu Irisunited Trading Company Ltd. specialized in sourcing the Yiwu market, with a focus on the comodities and differnet imported and exported products serving to and from the local market.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shenzhen, China",
        tag: "R&D Center",
        description:
          "The Shenzhen Company focuses on research and development of green solutions, utilizing advanced photocatalytic processes to address issues related to air surface purification and organic pollution. The branch develops systems and technologies aimed at improving health, energy efficiency, and environmental outcomes. These solutions are integrated into products designed to replicate natural processes and enhance purification capabilities.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Yiwu, China",
        tag: "Food Sourcing",
        description:
          "The Import & Export Company specializes in the sourcing and trading of frozen foods and raw materials tailored to the needs of the Chinese market. Leveraging an extensive and reliable supplier network, it ensures the consistent delivery of high-quality goods that meet stringent standards. The branch also focuses on maintaining competitive pricing, optimizing supply chain efficiency, and fostering long-term partnerships to support diverse client requirements.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai, China",
        tag: "Manufacturing",
        description:
          "Manufacturing facility specializes in producing high-quality cosmetics and household products for proprietary brands and global partners. Key offerings include premium skincare and haircare products, crafted with advanced techniques, and an array of household solutions such as air purifiers, furniture polish, surface cleaners, and drain openers. All products prioritize effectiveness, durability, and stringent quality standards.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai, China",
        tag: "Pet Products",
        description:
          "A company specializing in pet products with a strong connection to the international market. To meet market demands effectively, it is essential to analyze consumer trends, product preferences, and regional requirements. The manufacturing entity should focus on producing high-quality, innovative pet products while maintaining flexibility to accommodate the branding and specifications of different associated brands (Leopard pet, Cuddly VE, .. ).",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai (Changning), China",
        tag: "Retail Branch",
        description:
          "Operates within the domestic market, specializing in managing multiple retail stores and online platforms dedicated to pet products. It emphasizes enhancing customer experience through targeted product offerings, efficient distribution, and responsive service across its various sales channels.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Japan",
        tag: "Under Establishment",
        description: "2026 Under Establishment.",
      },
      {
        icon: "/images/bullet-blue.svg",
        title: "Singapore",
        tag: "Analysis Hub",
        description:
          "Specializes in analyzing industries and companies by examining operations and financial statements to forecast performance and assess investment values. The industry analysis focuses on specific sectors to understand their dynamics, forming the basis for company analysis.In addition to sourcing different Experts for material Manufacturing and products global reach.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Hong Kong",
        tag: "Sourcing Office",
        description:
          "IRISUNITED GROUP IMPORT&EXPORT CO.,LIMITED specialized in sourcing the Global Brands, linked and partneered with IrisUnited Group, ensuring the right sourcing and high end products requried by the global renowned brands.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Yiwu, China",
        tag: "Garment Factory",
        description:
          "The company including the factory presence is a platform manufacturer of garments for global brands, specializing in providing comprehensive production services. These include fabric sourcing, pattern development, garment design, and pre-production sampling to ensure alignment with client specifications. The company focuses on delivering garments that meet required quality standards and production parameters.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Hong Kong",
        tag: "Trading Desk",
        description:
          "IRISUNITED INVESTING GROUP LTD is the main holding group managing a network of domestic and international companies. It oversees operations, ensuring alignment with strategic goals and efficient resource utilization across subsidiaries.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Hong Kong",
        tag: "Partnership Desk",
        description:
          "Focuses on serving international customers by identifying trading opportunities, managing bids, and facilitating global partnerships. It provides tailored solutions, ensuring companies have the necessary facilities and goods to thrive in international markets.",
      },
      {
        icon: "/images/bullet-green.svg",
        title: "London, UK",
        tag: "European Office",
        description:
          "Our London office serves as the European headquarters, coordinating operations across the continent and facilitating trade relationships with European partners.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Dubai, UAE",
        tag: "MENA Office",
        description:
          "The Dubai branch oversees operations throughout the Middle East and North Africa region, developing strategic partnerships and market opportunities.",
      },
      // {
      //   icon: "/images/yellowBullet.svg",
      //   title: "United Arab Emirates",
      //   tag: "E-Trading",
      //   description:
      //     "One Technology FZ-LLC specializes in multi-sector E-Trading activities, including: Equipment E-Trading, Garments, Textiles & Gifts E-Trading, Household, Professional & Personal Goods E-Trading, Portal Products and Services E-Trading, Publications and Media Materials E-Trading, Sport & Recreational Events Tickets E-Trading, and Vehicles E-Trading.",
      // },
      {
        icon: "/images/yellowBullet.svg",
        title: "Doha, Qatar",
        tag: "Regional Hub",
        description:
          "Qatar IRISUNITED INVESTING GROUP LTD acts as a regional hub for cross-border partnerships and innovation-driven growth. It strengthens the group’s Gulf and global positioning, aligning regional initiatives with corporate objectives.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Muscat, Oman",
        tag: "Regional Operations",
        description:
          "Omani IRISUNITED INVESTING GROUP LTD supports resource optimization and regional collaboration, providing strong ties with Gulf industries and government entities. It plays a key role in integrating operations across the Arabian Peninsula.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Cairo, Egypt",
        tag: "North Africa HQ",
        description:
          "Egypt IRISUNITED INVESTING GROUP LTD anchors the group’s North African presence. It provides access to one of the region’s largest consumer and industrial markets, focusing on trade, manufacturing, and distribution expansion.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Amman, Jordan",
        tag: "Cross-Jordan Company",
        description:
          "Cross-Jordan Company strengthens the group’s presence in Jordan and the Levant, managing regional investments and fostering partnerships to support local and cross-border growth.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Aqaba, Jordan",
        tag: "Green Solutions",
        description:
          "PureSEEN Hawama Co. Ltd. is a pioneer in green solutions, specializing in innovative air and surface purification technologies that disinfect, decontaminate, deodorize, and depollute environments on both small and industrial scales.",
      },
      {
        icon: "/images/bullet-online.svg",
        title: "Online Platforms",
        tag: "E-commerce",
        description:
          "We maintain a strong presence across several online platforms to ensure our food products reach consumers directly. Our registered and authorized stores are available on: Taobao, Alibaba, Redbook, TikTok, WeChat mini app, and Pinduoduo.",
      },
    ],
  },
  {
    id: "pills-asia",
    label: "Asia",
    accordion: [
      {
        icon: "/images/yellowBullet.svg",
        title: "Riyadh, Kingdom of Saudi Arabia-",
        tag: "headquarter Global",
        description:
          "IRISUNITED INVESTING GROUP LTD Serves as the principal holding of3ice and corporate command center. It provides strategic direction, 3inancial governance, and oversees the group’s long-term vision for sustainable global growth.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai, China",
        tag: "Headquarters",
        description:
          "IRISUNITED INVESTING GROUP LTD is the main holding group managing a network of domestic and international companies. It oversees operations, ensuring alignment with strategic goals and efficient resource utilization across subsidiaries.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai, China",
        tag: "Vehicle Export",
        description:
          "The Shanghai Import and Export Company specializes in serving the Shanghai market, with a focus on the export of cars and vehicles to the global market. This branch ensures streamlined operations, compliance with international trade standards, and the delivery of high-quality vehicles, catering to the demands of both domestic and international clients.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai, China",
        tag: "Trading Hub",
        description:
          "Shanghai IRISUNITED is the hub for our global investment and trading activities, specializing in manufacturing, supply, and distribution across various commodities. , Shanghai IRISUNITED plays a vital role in the development and deployment of our various needs of our customers and connections.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai, China",
        tag: "Retail & Food Trade",
        description:
          "Shanghai Alriyad Company operates supermarkets, online stores, and the Milestone Center, which serves as a platform for distributing international and imported food products while fostering trade relations between China and the Arab world. The center emphasizes the exchange of goods and cultural insights, contributing to enhanced cooperation and mutual benefit between these regions.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Yiwu, China",
        tag: "Commodities Ops",
        description:
          "Yiwu Irisunited Trading Company Ltd. specialized in sourcing the Yiwu market, with a focus on the comodities and differnet imported and exported products serving to and from the local market.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shenzhen, China",
        tag: "R&D Center",
        description:
          "The Shenzhen Company focuses on research and development of green solutions, utilizing advanced photocatalytic processes to address issues related to air surface purification and organic pollution. The branch develops systems and technologies aimed at improving health, energy efficiency, and environmental outcomes. These solutions are integrated into products designed to replicate natural processes and enhance purification capabilities.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Yiwu, China",
        tag: "Food Sourcing",
        description:
          "The Import & Export Company specializes in the sourcing and trading of frozen foods and raw materials tailored to the needs of the Chinese market. Leveraging an extensive and reliable supplier network, it ensures the consistent delivery of high-quality goods that meet stringent standards. The branch also focuses on maintaining competitive pricing, optimizing supply chain efficiency, and fostering long-term partnerships to support diverse client requirements.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai, China",
        tag: "Manufacturing",
        description:
          "Manufacturing facility specializes in producing high-quality cosmetics and household products for proprietary brands and global partners. Key offerings include premium skincare and haircare products, crafted with advanced techniques, and an array of household solutions such as air purifiers, furniture polish, surface cleaners, and drain openers. All products prioritize effectiveness, durability, and stringent quality standards.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai, China",
        tag: "Pet Products",
        description:
          "A company specializing in pet products with a strong connection to the international market. To meet market demands effectively, it is essential to analyze consumer trends, product preferences, and regional requirements. The manufacturing entity should focus on producing high-quality, innovative pet products while maintaining flexibility to accommodate the branding and specifications of different associated brands (Leopard pet, Cuddly VE, .. ).",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Shanghai (Changning), China",
        tag: "Retail Branch",
        description:
          "Operates within the domestic market, specializing in managing multiple retail stores and online platforms dedicated to pet products. It emphasizes enhancing customer experience through targeted product offerings, efficient distribution, and responsive service across its various sales channels.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Japan",
        tag: "Under Establishment",
        description: "2026 Under Establishment.",
      },
      {
        icon: "/images/bullet-blue.svg",
        title: "Singapore",
        tag: "Analysis Hub",
        description:
          "Specializes in analyzing industries and companies by examining operations and financial statements to forecast performance and assess investment values. The industry analysis focuses on specific sectors to understand their dynamics, forming the basis for company analysis.In addition to sourcing different Experts for material Manufacturing and products global reach.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Hong Kong",
        tag: "Sourcing Office",
        description:
          "IRISUNITED GROUP IMPORT&EXPORT CO.,LIMITED specialized in sourcing the Global Brands, linked and partneered with IrisUnited Group, ensuring the right sourcing and high end products requried by the global renowned brands.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Yiwu, China",
        tag: "Garment Factory",
        description:
          "The company including the factory presence is a platform manufacturer of garments for global brands, specializing in providing comprehensive production services. These include fabric sourcing, pattern development, garment design, and pre-production sampling to ensure alignment with client specifications. The company focuses on delivering garments that meet required quality standards and production parameters.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Hong Kong",
        tag: "Trading Desk",
        description:
          "IRISUNITED INVESTING GROUP LTD is the main holding group managing a network of domestic and international companies. It oversees operations, ensuring alignment with strategic goals and efficient resource utilization across subsidiaries.",
      },
      {
        icon: "/images/bullet-red.svg",
        title: "Hong Kong",
        tag: "Partnership Desk",
        description:
          "Focuses on serving international customers by identifying trading opportunities, managing bids, and facilitating global partnerships. It provides tailored solutions, ensuring companies have the necessary facilities and goods to thrive in international markets.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Dubai, UAE",
        tag: "MENA Office",
        description:
          "The Dubai branch oversees operations throughout the Middle East and North Africa region, developing strategic partnerships and market opportunities.",
      },
      // {
      //   icon: "/images/yellowBullet.svg",
      //   title: "United Arab Emirates",
      //   tag: "E-Trading",
      //   description:
      //     "One Technology FZ-LLC specializes in multi-sector E-Trading activities, including: Equipment E-Trading, Garments, Textiles & Gifts E-Trading, Household, Professional & Personal Goods E-Trading, Portal Products and Services E-Trading, Publications and Media Materials E-Trading, Sport & Recreational Events Tickets E-Trading, and Vehicles E-Trading.",
      // },
      {
        icon: "/images/yellowBullet.svg",
        title: "Doha, Qatar",
        tag: "Regional Hub",
        description:
          "Qatar IRISUNITED INVESTING GROUP LTD acts as a regional hub for cross-border partnerships and innovation-driven growth. It strengthens the group’s Gulf and global positioning, aligning regional initiatives with corporate objectives.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Muscat, Oman",
        tag: "Regional Operations",
        description:
          "Omani IRISUNITED INVESTING GROUP LTD supports resource optimization and regional collaboration, providing strong ties with Gulf industries and government entities. It plays a key role in integrating operations across the Arabian Peninsula.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Amman, Jordan",
        tag: "Cross-Jordan Company",
        description:
          "Cross-Jordan Company strengthens the group’s presence in Jordan and the Levant, managing regional investments and fostering partnerships to support local and cross-border growth.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Aqaba, Jordan",
        tag: "Green Solutions",
        description:
          "PureSEEN Hawama Co. Ltd. is a pioneer in green solutions, specializing in innovative air and surface purification technologies that disinfect, decontaminate, deodorize, and depollute environments on both small and industrial scales.",
      },
    ],
  },
  {
    id: "pills-europe",
    label: "Europe",
    accordion: [
      {
        icon: "/images/bullet-green.svg",
        title: "London, UK",
        tag: "European Office",
        description:
          "Our London office serves as the European headquarters, coordinating operations across the continent and facilitating trade relationships with European partners.",
      },
    ],
  },
  {
    id: "pills-east",
    label: "Middle East",
    accordion: [
      {
        icon: "/images/yellowBullet.svg",
        title: "Riyadh, Kingdom of Saudi Arabia-",
        tag: "headquarter Global",
        description:
          "IRISUNITED INVESTING GROUP LTD Serves as the principal holding of3ice and corporate command center. It provides strategic direction, 3inancial governance, and oversees the group’s long-term vision for sustainable global growth.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Dubai, UAE",
        tag: "MENA Office",
        description:
          "The Dubai branch oversees operations throughout the Middle East and North Africa region, developing strategic partnerships and market opportunities.",
      },
      // {
      //   icon: "/images/yellowBullet.svg",
      //   title: "United Arab Emirates",
      //   tag: "E-Trading",
      //   description:
      //     "One Technology FZ-LLC specializes in multi-sector E-Trading activities, including: Equipment E-Trading, Garments, Textiles & Gifts E-Trading, Household, Professional & Personal Goods E-Trading, Portal Products and Services E-Trading, Publications and Media Materials E-Trading, Sport & Recreational Events Tickets E-Trading, and Vehicles E-Trading.",
      // },
      {
        icon: "/images/yellowBullet.svg",
        title: "Doha, Qatar",
        tag: "Regional Hub",
        description:
          "Qatar IRISUNITED INVESTING GROUP LTD acts as a regional hub for cross-border partnerships and innovation-driven growth. It strengthens the group’s Gulf and global positioning, aligning regional initiatives with corporate objectives.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Muscat, Oman",
        tag: "Regional Operations",
        description:
          "Omani IRISUNITED INVESTING GROUP LTD supports resource optimization and regional collaboration, providing strong ties with Gulf industries and government entities. It plays a key role in integrating operations across the Arabian Peninsula.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Cairo, Egypt",
        tag: "North Africa HQ",
        description:
          "Egypt IRISUNITED INVESTING GROUP LTD anchors the group’s North African presence. It provides access to one of the region’s largest consumer and industrial markets, focusing on trade, manufacturing, and distribution expansion.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Amman, Jordan",
        tag: "Cross-Jordan Company",
        description:
          "Cross-Jordan Company strengthens the group’s presence in Jordan and the Levant, managing regional investments and fostering partnerships to support local and cross-border growth.",
      },
      {
        icon: "/images/yellowBullet.svg",
        title: "Aqaba, Jordan",
        tag: "Green Solutions",
        description:
          "PureSEEN Hawama Co. Ltd. is a pioneer in green solutions, specializing in innovative air and surface purification technologies that disinfect, decontaminate, deodorize, and depollute environments on both small and industrial scales.",
      },
    ],
  },
  {
    id: "pills-virtual",
    label: "Virtual",
    accordion: [
      {
        icon: "/images/bullet-online.svg",
        title: "Online Platforms",
        tag: "E-commerce",
        description:
          "We maintain a strong presence across several online platforms to ensure our food products reach consumers directly. Our registered and authorized stores are available on: Taobao, Alibaba, Redbook, TikTok, WeChat mini app, and Pinduoduo.",
      },
    ],
  },
];

// دالة فلترة العناصر داخل كل تاب
const filteredAccordion = (tab) => {
  const filterText = (tabFilters[tab.id] || "").toLowerCase();
  if (!filterText) return tab.accordion;
  return tab.accordion.filter(
    (item) =>
      item.title.toLowerCase().includes(filterText) ||
      item.tag.toLowerCase().includes(filterText) ||
      item.description.toLowerCase().includes(filterText)
  );
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.card {
  transition: all 0.3s ease-in-out;
}
.card:hover {
  border: 1px solid #df0031;
}

.global-padding {
  padding-left: 80px;
  padding-right: 80px;
  padding-bottom: 80px;
}

@media (max-width: 767px) {
  .global-padding {
    padding-left: 50px;
    padding-right: 50px;
    padding-bottom: 80px;
  }
}
@media (max-width: 550px) {
  .global-padding {
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 80px;
  }
}
</style>
